import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';

export const FormWrapper = styled.div<{ labelPosition: string }>`
    display: flex;
    flex-direction: ${({ labelPosition }) =>
        labelPosition === 'column' ? 'column' : 'row'};
    align-items: ${({ labelPosition }) =>
        labelPosition === 'column' ? 'flex-start' : 'center'};

    label {
        margin: ${({ labelPosition }) =>
            labelPosition === 'column' ? '0 0 8px 0' : '0 10px 0 0'};
        font-size: 14px;
        font-weight: 600;
    }

    .MuiInputBase-root {
        height: 37px;
        font-size: 14px;
        min-width: 80px;
        background-color: #fff;
    }

    .MuiOutlinedInput-input {
        padding: 9.5px 14px;
    }

    .MuiSelect-select:focus {
        background-color: #fff;
    }

    .MuiList-root {
        font-size: 14px;
    }
`;

export const StyledMenuItem = styled(MenuItem)`
    &.MuiMenuItem-root {
        font-size: 14px;
    }

    .MuiCheckbox-root {
            padding: 5px;
    }
`;
